/* FITURA editorial theme runtime — motion + real store cart/product logic */
(() => {
  const F = window.FITURA || {};
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const expo = t => Math.min(1, 1.001 - Math.pow(2, -10 * t));
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const store = {
    get(k, s = sessionStorage) { try { return s.getItem(k); } catch (e) { return null; } },
    set(k, v, s = sessionStorage) { try { s.setItem(k, v); } catch (e) {} }
  };

  /* ---------- money ---------- */
  const money = cents => {
    const fmt = F.moneyFormat || '₪{{amount}}';
    const n = (cents / 100);
    const two = n.toFixed(2), noDec = Math.round(n).toString();
    const comma = two.replace('.', ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: two.replace(/\B(?=(\d{3})+(?!\d))/g, ','), amount_no_decimals: noDec,
      amount_with_comma_separator: comma, amount_no_decimals_with_comma_separator: noDec
    })[k] ?? two);
  };

  /* ---------- intro (once per session) + page curtain ---------- */
  const intro = $('.intro'), curtain = $('.curtain');
  if (intro && !reduced && store.get('fituraIntro') !== '1' && !document.documentElement.classList.contains('shopify-design-mode')) {
    intro.hidden = false;
    document.documentElement.classList.add('intro-playing');
    setTimeout(() => {
      intro.classList.add('is-done'); document.documentElement.classList.remove('intro-playing');
      store.set('fituraIntro', '1'); setTimeout(() => intro.remove(), 1200);
    }, 2700);
  } else if (intro) intro.remove();

  if (curtain && store.get('fituraCurtain') === '1') {
    store.set('fituraCurtain', '0');
    curtain.style.transition = 'none'; curtain.classList.add('is-covering');
    requestAnimationFrame(() => requestAnimationFrame(() => {
      curtain.style.transition = ''; curtain.classList.remove('is-covering'); curtain.classList.add('is-leaving');
      setTimeout(() => curtain.classList.remove('is-leaving'), 750);
    }));
  }
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href]');
    if (!a || reduced || !curtain || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin || url.pathname === location.pathname || /\/(checkout|cart|account)/.test(url.pathname) || a.hasAttribute('data-cart-open')) return;
    e.preventDefault();
    curtain.classList.add('is-covering'); store.set('fituraCurtain', '1');
    setTimeout(() => { location.href = url.href; }, 560);
  });
  addEventListener('pageshow', e => { if (e.persisted && curtain) curtain.classList.remove('is-covering', 'is-leaving'); });

  /* ---------- smooth scroll ---------- */
  let lenis = null;
  const hasGsap = () => !!(window.gsap && window.ScrollTrigger);
  if (!reduced && window.Lenis && !document.documentElement.classList.contains('shopify-design-mode')) {
    lenis = new Lenis({ duration: 1.5, easing: expo, smoothWheel: true, touchMultiplier: 2 });
    if (hasGsap()) { gsap.registerPlugin(ScrollTrigger); lenis.on('scroll', ScrollTrigger.update); gsap.ticker.add(t => lenis.raf(t * 1000)); gsap.ticker.lagSmoothing(0); }
    else { const raf = t => { lenis.raf(t); requestAnimationFrame(raf); }; requestAnimationFrame(raf); }
  }
  const scrollToEl = el => lenis ? lenis.scrollTo(el, { offset: -90, duration: 1.6, easing: expo }) : el.scrollIntoView({ behavior: 'smooth' });

  /* ---------- reveals ---------- */
  // A .reveal--clip element starts fully clipped (clip-path: inset(0 0 100% 0)); Chrome counts the target's own
  // clip-path, so it never "intersects". Watch its parent instead and reveal the clipped child from there.
  const proxied = new Map();
  const io = new IntersectionObserver(es => es.forEach(en => {
    if (!en.isIntersecting) return;
    const t = en.target;
    if (t.matches('.reveal,.reveal--scale,.reveal--fade') || !proxied.has(t)) t.classList.add('is-visible');
    (proxied.get(t) || []).forEach(c => c.classList.add('is-visible'));
    io.unobserve(en.target);
  }), { threshold: .05, rootMargin: '0px 0px -40px 0px' });
  $$('.reveal,.reveal--scale,.reveal--fade').forEach(el => io.observe(el));
  $$('.reveal--clip').forEach(el => {
    const p = el.parentElement || el;
    if (!proxied.has(p)) { proxied.set(p, []); io.observe(p); }
    proxied.get(p).push(el);
  });
  // belt and braces: reveal anything that is on screen but still hidden (e.g. observer quirks)
  const sweep = () => $$('.reveal:not(.is-visible),.reveal--scale:not(.is-visible),.reveal--fade:not(.is-visible),.reveal--clip:not(.is-visible)').forEach(el => {
    const r = (el.matches('.reveal--clip') ? el.parentElement || el : el).getBoundingClientRect();
    if (r.top < innerHeight - 40 && r.bottom > 0) el.classList.add('is-visible');
  });
  let sweepT = 0; addEventListener('scroll', () => { clearTimeout(sweepT); sweepT = setTimeout(sweep, 150); }, { passive: true });
  addEventListener('load', () => setTimeout(sweep, 300));

  /* only play videos while on screen */
  const vio = new IntersectionObserver(es => es.forEach(en => { const v = en.target; if (en.isIntersecting) { const p = v.play(); p && p.catch(() => {}); } else v.pause(); }), { threshold: .15 });
  $$('video[autoplay]').forEach(v => { v.muted = true; v.playsInline = true; vio.observe(v); });

  /* ---------- header ---------- */
  const header = $('[data-header]'), sticky = $('[data-sticky]');
  let lastY = 0, ticking = false;
  addEventListener('scroll', () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => {
      const y = scrollY;
      header && header.classList.toggle('header--hidden', y > 100 && y > lastY && !header.classList.contains('menu-open'));
      header && header.classList.toggle('header--condensed', y > innerHeight * .6);
      sticky && sticky.classList.toggle('is-visible', y > innerHeight * .8);
      lastY = y; ticking = false;
    });
  }, { passive: true });

  const toggle = $('[data-menu-toggle]'), links = $('[data-menu]');
  const setMenu = open => {
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', open); links.classList.toggle('is-open', open);
    if (open) header.classList.add('menu-open');
    else setTimeout(() => links.classList.contains('is-open') || header.classList.remove('menu-open'), 800);
    document.body.style.overflow = open ? 'hidden' : ''; lenis && (open ? lenis.stop() : lenis.start());
  };
  toggle && toggle.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));

  /* ---------- countdown (same rolling logic + storage key as the old theme) ---------- */
  const cd = $('[data-countdown]');
  if (cd) {
    const H = (+cd.dataset.hours || 44) * 36e5, KEY = 'fituraCountdownEndTime';
    let end = +store.get(KEY, localStorage) || 0;
    const reset = () => { end = Date.now() + H; store.set(KEY, end, localStorage); };
    if (!end || Date.now() > end) reset();
    const pad = n => String(n).padStart(2, '0'), el = k => cd.querySelector(`[data-cd="${k}"]`);
    const tick = () => { let d = end - Date.now(); if (d < 0) { reset(); d = end - Date.now(); }
      el('d').textContent = pad(Math.floor(d / 864e5)); el('h').textContent = pad(Math.floor(d % 864e5 / 36e5));
      el('m').textContent = pad(Math.floor(d % 36e5 / 6e4)); el('s').textContent = pad(Math.floor(d % 6e4 / 1e3)); };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- toast ---------- */
  const toastEl = $('[data-toast]');
  const toast = msg => { if (!toastEl) return; toastEl.textContent = msg; toastEl.classList.add('is-on'); clearTimeout(toast.t); toast.t = setTimeout(() => toastEl.classList.remove('is-on'), 2800); };

  /* ---------- cart (real store cart via AJAX API) ---------- */
  const cartEl = $('[data-cart]'), scrim = $('.scrim'), rowsEl = $('[data-cart-rows]');
  const setCart = open => { if (!cartEl) return; cartEl.classList.toggle('is-open', open); scrim.classList.toggle('is-open', open); lenis && (open ? lenis.stop() : lenis.start()); };
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const HE = { black: 'שחור', navy: 'כחול לילה', gray: 'אפור', grey: 'אפור', pink: 'ורוד', green: 'ירוק', blue: 'תכלת', white: 'לבן' };
  const heVariant = t => t.split(' / ').map(p => HE[p.trim().toLowerCase()] || p).join(' · ');
  function renderCart(cart) {
    if (!rowsEl) return;
    rowsEl.innerHTML = cart.items.map((it, i) => `
      <div class="cart__row" style="animation-delay:${.15 + i * .07}s">
        ${it.image ? `<img src="${it.image}${it.image.includes('?') ? '&' : '?'}width=120" alt="" width="48" height="58">` : ''}
        <div>${esc(it.product_title)}${it.variant_title && it.variant_title !== 'Default Title' ? `<small>${esc(heVariant(it.variant_title))}</small>` : ''}
          <span class="qty"><button type="button" data-line="${i + 1}" data-qty="${it.quantity - 1}" aria-label="הפחתה">−</button><span class="tabnums">${it.quantity}</span><button type="button" data-line="${i + 1}" data-qty="${it.quantity + 1}" aria-label="הוספה">+</button><button type="button" class="cart__remove" data-line="${i + 1}" data-qty="0">הסרה</button></span></div>
        <span class="tabnums">${money(it.final_line_price)}</span>
      </div>`).join('');
    $$('[data-cart-count]').forEach(c => { c.textContent = cart.item_count; c.classList.add('bump'); setTimeout(() => c.classList.remove('bump'), 300); });
    const tot = $('[data-cart-total]'); tot && (tot.textContent = money(cart.total_price));
  }
  const fetchCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(c => { renderCart(c); return c; });
  async function addToCart(id, quantity = 1) {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity }] }) });
    const j = await r.json();
    if (!r.ok) { toast(j.description || j.message || 'לא הצלחנו להוסיף לסל'); throw new Error('add failed'); }
    await fetchCart(); setCart(true);
  }
  async function changeLine(line, quantity) {
    rowsEl.classList.add('is-loading');
    const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +line, quantity: +quantity }) });
    rowsEl.classList.remove('is-loading');
    renderCart(await r.json());
  }
  if (cartEl) fetchCart();

  /* ---------- product page ---------- */
  const section = $('[data-product-section]');
  let product = null, selected = [];
  if (section) {
    try { product = JSON.parse($('[data-product-json]').textContent); } catch (e) {}
    const form = $('[data-product-form]', section), idInput = $('[data-variant-id]', section);
    const atc = $('[data-atc]', section);
    const current = () => product && product.variants.find(v => v.id === +idInput.value);
    if (product) selected = (current() || product.variants[0]).options.slice();

    const gallery = $('[data-gallery]', section), track = gallery && $('.gallery__track', gallery);
    const dots = gallery ? $$('.gallery__dots span', gallery) : [];
    const idx = () => track ? Math.round(Math.abs(track.scrollLeft) / track.clientWidth) : 0;
    const goSlide = i => track && track.scrollTo({ left: -1 * i * track.clientWidth * (getComputedStyle(track).direction === 'rtl' ? 1 : -1), behavior: 'smooth' });
    const syncDots = () => { const i = idx(); dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
      const p = $('[data-g="-1"]', gallery), n = $('[data-g="1"]', gallery); if (p) { p.disabled = i === 0; n.disabled = i === dots.length - 1; } };
    if (track) { track.addEventListener('scroll', () => requestAnimationFrame(syncDots), { passive: true }); syncDots();
      $$('[data-g]', gallery).forEach(b => b.addEventListener('click', () => goSlide(Math.max(0, Math.min(dots.length - 1, idx() + +b.dataset.g))))); }

    const updateVariant = () => {
      const v = product.variants.find(x => x.options.every((o, i) => o === selected[i]));
      $$('[data-option-index]', section).forEach(box => {
        const i = +box.dataset.optionIndex;
        $$('[data-value]', box).forEach(b => { const on = b.dataset.value === selected[i]; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
        const active = $$('[data-value]', box).find(b => b.dataset.value === selected[i]);
        const lab = $('[data-option-label]', box); if (lab && active) lab.textContent = active.getAttribute('aria-label') || active.childNodes[0].textContent.trim();
      });
      if (!v) { atc.disabled = true; $('[data-atc-label]', atc).textContent = 'לא זמין'; return; }
      idInput.value = v.id;
      $('[data-price]', section).textContent = money(v.price);
      const cmp = $('[data-compare]', section), save = $('[data-save]', section), has = v.compare_at_price > v.price;
      cmp.hidden = save.hidden = !has; if (has) { cmp.textContent = money(v.compare_at_price); save.textContent = 'חוסכים ' + money(v.compare_at_price - v.price); }
      atc.disabled = !v.available; $('[data-atc-label]', atc).textContent = v.available ? 'הוספה לסל' : 'אזל מהמלאי';
      const sp = $('[data-sticky-price]'); sp && (sp.textContent = money(v.price));
      if (v.media_id && track) { const slides = $$('.gallery__slide', track); const i = slides.findIndex(s => +s.dataset.mediaId === v.media_id); i > -1 && goSlide(i); }
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    };
    section.addEventListener('click', e => {
      const b = e.target.closest('[data-value]'); if (!b || !product) return;
      selected[+b.closest('[data-option-index]').dataset.optionIndex] = b.dataset.value; updateVariant();
    });
    form && form.addEventListener('submit', async e => {
      e.preventDefault(); if (atc.disabled) return;
      atc.disabled = true;
      try { await addToCart(idInput.value, 1); atc.classList.add('is-added'); setTimeout(() => atc.classList.remove('is-added'), 1800); }
      catch (err) {} finally { atc.disabled = false; }
    });
    const sa = $('[data-sticky-add]'); sa && sa.addEventListener('click', () => form.requestSubmit());
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', e => {
    const t = e.target;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); fetchCart(); setCart(true); return; }
    if (t.closest('[data-cart-close]')) { setCart(false); return; }
    const q = t.closest('[data-line]'); if (q) { changeLine(q.dataset.line, q.dataset.qty); return; }
    const qa = t.closest('[data-quick-add]'); if (qa) { qa.disabled = true; addToCart(qa.dataset.quickAdd).finally(() => qa.disabled = false); return; }
    const st = t.closest('[data-scroll-to]'); if (st) { const el = document.getElementById(st.dataset.scrollTo); el && scrollToEl(el); return; }
    if (links && links.classList.contains('is-open') && t.closest('[data-menu] a')) setMenu(false);
  });
  addEventListener('keydown', e => { if (e.key === 'Escape') { setCart(false); if (links && links.classList.contains('is-open')) setMenu(false); } });

  /* before/after */
  document.addEventListener('input', e => { const r = e.target.closest('[data-ba-range]'); if (r) r.parentElement.style.setProperty('--pos', r.value + '%'); });

  /* cursor pill on product cards */
  const pill = $('.cursor-pill');
  if (pill && fine && window.gsap) {
    const xTo = gsap.quickTo(pill, 'x', { duration: .45, ease: 'power3' }), yTo = gsap.quickTo(pill, 'y', { duration: .45, ease: 'power3' });
    addEventListener('mousemove', e => { xTo(e.clientX + 16); yTo(e.clientY + 16); });
    document.addEventListener('mouseover', e => { const c = e.target.closest('[data-pill]');
      if (c) { $('[data-pill-price]', pill).textContent = c.dataset.pillPrice || ''; pill.classList.add('is-active'); } else pill.classList.remove('is-active'); });
  }

  /* colour swap list (home) */
  const swapOn = b => { const root = b.closest('[data-swap-root]'); if (!root) return;
    $$('.swap__item,.swap__stage img', root).forEach(el => el.classList.toggle('is-active', el.dataset.key === b.dataset.key));
    const cap = $('[data-swap-caption]', root); cap && (cap.textContent = b.textContent.trim()); };
  ['mouseover', 'focusin', 'click'].forEach(ev => document.addEventListener(ev, e => { const b = e.target.closest('.swap__item'); b && swapOn(b); }));

  /* collection filter chips */
  document.addEventListener('click', e => {
    const chip = e.target.closest('[data-filter]'); if (!chip) return;
    const root = chip.closest('[data-filter-root]'); if (!root) return;
    $$('[data-filter]', root).forEach(c => c.classList.toggle('is-active', c === chip));
    const allow = chip.dataset.filter === 'all' ? null : (chip.dataset.handles || '').split(',');
    $$('.product[data-handle]', root).forEach(p => p.classList.toggle('is-filtered', !!allow && !allow.includes(p.dataset.handle)));
    hasGsap() && ScrollTrigger.refresh();
  });

  /* hotspots: tap to open on touch screens */
  document.addEventListener('click', e => {
    const h = e.target.closest('.hotspot'); if (!h || fine || e.target.closest('.hotspot__card')) return;
    e.preventDefault(); $$('.hotspot.is-open').forEach(o => o !== h && o.classList.remove('is-open')); h.classList.toggle('is-open');
  });

  /* numbers without GSAP: just show the final value */
  if (reduced || !hasGsap()) $$('[data-count]').forEach(el => el.textContent = el.dataset.count + (el.dataset.suffix || ''));

  /* GSAP-driven: hero parallax, sideways story, count-up */
  if (!reduced && hasGsap()) {
    const par = $('[data-parallax]');
    par && gsap.to(par, { yPercent: 12, ease: 'none', scrollTrigger: { trigger: par.parentElement, start: 'top top', end: 'bottom top', scrub: true } });
    const isRTL = document.documentElement.dir === 'rtl';
    $$('[data-hscroll]').forEach(sec => {
      const track = $('.hscroll__track', sec), dist = () => Math.max(0, track.scrollWidth - innerWidth);
      const tween = gsap.to(track, { x: () => (isRTL ? 1 : -1) * dist(), ease: 'none',
        scrollTrigger: { trigger: sec, pin: true, scrub: 1, start: 'top top', end: () => '+=' + dist(), invalidateOnRefresh: true, anticipatePin: 1 } });
      $$('.hpanel__inner', sec).forEach(inner => gsap.fromTo(inner, { xPercent: isRTL ? -7 : 7 }, { xPercent: isRTL ? 7 : -7, ease: 'none',
        scrollTrigger: { trigger: inner.parentElement, containerAnimation: tween, start: 'left right', end: 'right left', scrub: true } }));
    });
    $$('[data-count]').forEach(el => { const o = { v: 0 }, target = +el.dataset.count || 0, suf = el.dataset.suffix || ''; el.textContent = '0' + suf;
      gsap.to(o, { v: target, duration: 1.8, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 85%', once: true }, onUpdate: () => el.textContent = Math.round(o.v) + suf }); });
  }

  /* parallax on image band */
  if (!reduced && hasGsap()) {
    $$('[data-band] img').forEach(img => gsap.fromTo(img, { yPercent: -6 }, { yPercent: 6, ease: 'none', scrollTrigger: { trigger: img.parentElement, start: 'top bottom', end: 'bottom top', scrub: true } }));
    addEventListener('load', () => ScrollTrigger.refresh());
    setTimeout(() => ScrollTrigger.refresh(), 2500); // after Judge.me renders
  }
})();
